module.exports = __webpack_public_path__ + "static/media/teygja_fotapressa_small.2f88d9a3.png";